var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"montilla-slot",class:{ 'montilla-slot--reserved': _vm.reserved && !!_vm.reservedStyle },style:(_vm.reservedStyle),attrs:{"data-montilla-slot":_vm.slug,"data-montilla-tags":_vm.tagsAttribute}})}
var staticRenderFns = []

export { render, staticRenderFns }